import React, { useState } from 'react';
import cx from 'classnames';

import Image from 'next/image';

import Typography from '../shared/Typography';
import { useViewport } from '@/hooks/useViewport';
import Input from '../shared/Input';
import Button from '../shared/Button';

type AboutUsSectionProps = {
  className?: string;
};

const AboutUsSection: React.FC<AboutUsSectionProps> = ({ className }) => {
  const { isMobile } = useViewport();

  const [firstName, setFirstName] = useState<string>('');

  const [lastName, setLastName] = useState<string>('');

  const [email, setEmail] = useState<string>('');

  return (
    <div
      className={cx(
        'flex flex-col items-center px-8 py-12 xl:flex-row xl:justify-between max-w-6xl mx-auto',
        className
      )}
    >
      <div className="flex flex-col text-center gap-6 xl:max-w-lg xl:text-left">
        <p className="font-extrabold font-sans uppercase text-black text-14">
          About Us
        </p>
        <div className={cx('w-full  mt-4 xl:hidden')}>
          <Typography type="h1" color="black">
            Keepsake Tales makes the most personalized children&lsquo;s books on
            the planet because we believe every child should know they are truly
            one-of-a-kind!
          </Typography>
        </div>
        <div className={cx('xl:w-592 hidden xl:block')}>
          <Typography type="mh1" color="black">
            Keepsake Tales makes the most personalized children&lsquo;s books on
            the planet because we believe every child should know they are truly
            one-of-a-kind!
          </Typography>
        </div>
        {/* <div className={cx('hidden xl:block xl:w-473 xl:mt-4')}>
          <Typography type="b2" color="black">
            We believe that every child has intrinsic value. And we’re building
            the world’s most personalized children’s books so that every child
            will understand that they matter.
          </Typography>
        </div> */}
        <Typography type="b2">
          We make every child the main character of their very own Keepsake Tale
          by starting with a photo (if you don&apos;t have a photo, don&apos;t
          worry! You can start without one, too.) That photo is magically
          transformed into illustrations used throughout the book. When kids see
          their personalized illustrations and name throughout their story, it
          boosts their confidence, helps them fall in love with reading, and
          brings a big smile to their faces.
        </Typography>

        <Typography type="b2">
          We&apos;ve got more books launching soon, so please keep in touch!
        </Typography>

        <form
          action="https://mykeepsaketales.us5.list-manage.com/subscribe/post?u=0d7c744b5c72c3837e7aa76e8&amp;id=a173a4bee9"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          target="_blank"
          noValidate
        >
          <Input
            type="text"
            name="FNAME"
            onChange={e => setFirstName(e.target.value)}
            value={firstName}
            className="w-full border-grey mt-4"
            placeholder="First Name"
          />
          <Input
            type="text"
            name="LNAME"
            onChange={e => setLastName(e.target.value)}
            value={lastName}
            className="w-full border-grey mt-2"
            placeholder="Last Name"
          />
          <Input
            type="email"
            name="EMAIL"
            onChange={e => setEmail(e.target.value)}
            value={email}
            className="w-full border-grey mt-2"
            placeholder="Email"
          />

          <Button
            className="text-center border border-primary h-14 mb-6 mt-4 w-full xl:w-64 "
            style={{
              fontFamily: 'Nunito',
              fontSize: 14,
              fontStyle: 'normal',
              fontWeight: 800
            }}
            type="submit"
            onClick={() => {
              setTimeout(() => {
                setFirstName('');
                setLastName('');
                setEmail('');
              }, 5000);
            }}
            aria-label="Keep in Touch"
          >
            Keep in Touch
          </Button>
        </form>
      </div>

      <Image
        className="mt-16"
        width={isMobile ? 240 : 310}
        height={isMobile ? 240 : 310}
        // layout="fill"
        src="/images/home/steps/select-stories.png"
      />
    </div>
  );
};

export default AboutUsSection;
